function isDesktop() {
    // Check user agent
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    // Check screen width
    const isWideScreen = window.innerWidth > 1024;
    
    // Check pointer type (most modern browsers)
    const hasHoverCapability = window.matchMedia("(hover: hover)").matches;
    
    return !isMobile && isWideScreen && hasHoverCapability;
}

var WAChangeTextTimer = null;
function WAChangeText(){
    if(WAChangeTextTimer != null){
        clearTimeout(WAChangeTextTimer);
    }

    if(!$('.spk-wsp-nft-text.showed p').get(0)){
        WAChangeTextTimer = setTimeout(function(){
            WAChangeText();
        }, 200);
    }else{
        $('.spk-wsp-nft-text.showed p').text(wa_popup_text).css({
            'color': '#333'
        });
    }
}


var akProductCounterTimer = null;

function akProductCounter() {
    if (akProductCounterTimer != null) {
        clearTimeout(akProductCounterTimer);
    }

    console.log("calling akProductCounter");

    // Count non-empty <li> elements
    var akProductCounterTmp = $('#product-grid > li:not(:empty)').length;

    // Get the last word dynamically from #ProductCount
    var text = $("#ProductCount").text().trim();
    var lastWord = text.split(/\s+/).filter(Boolean).pop() || ""; // fallback if empty
    $("#ProductCount").text(`${akProductCounterTmp} ${lastWord}`);

    // Do the same for #ProductCountDesktop
    var text2 = $("#ProductCountDesktop").text().trim();
    var lastWord2 = text2.split(/\s+/).filter(Boolean).pop() || "";
    $("#ProductCountDesktop").text(`${akProductCounterTmp} ${lastWord2}`);

    // Do the same for home page carousel items
    var akProductCounterTmp3 = $('[data-section-type]:nth-child(3) .flickity-slider > div').length;
    if(akProductCounterTmp3){
        var text3 = $("#ProductCount").text().trim();
        var lastWord3 = text3.split(/\s+/).filter(Boolean).pop() || "";
        $("#ProductCount").text(`${akProductCounterTmp3} ${lastWord3}`);
    }

    var akProductCounterTmp4 = $('#Slider-template--20614588662027__featured_collection_Hipxgm > div').length;
    if(akProductCounterTmp4){
        var text4 = $("#ProductCount").text().trim();
        var lastWord4 = text4.split(/\s+/).filter(Boolean).pop() || "";
        $("#ProductCount").text(`${akProductCounterTmp4} ${lastWord4}`);
    }
    

    // Call again after 400ms
    akProductCounterTimer = setTimeout(akProductCounter, 400);
}

var akSelectedLocaleCode =
    localStorage.getItem('fithome_selected_language') || '';

$(function(){
    /* start currency and price converter */

    $(document).on('click', '.AK-modal-content [data-language-code]', function(){
        akSelectedLocaleCode = $(this).data('language-code');

        // Guardar l'idioma seleccionat
        localStorage.setItem('fithome_selected_language', akSelectedLocaleCode);
        console.log('Idioma guardat:', akSelectedLocaleCode);
        console.log('País guardat:', localStorage.getItem('akSelectedCountry_'));
    });
    var currencySymbols = {
        USD: '$',
        GBP: '£',
        EUR: '€',
        CAD: 'C$',
        AUD: 'A$',
        NZD: 'NZ$',
        JPY: '¥',
        INR: '₹',
        PKR: 'Rs',
        AED: 'د.إ',
        SAR: '﷼',
        CHF: 'CHF',
        CNY: '¥',
        SEK: 'kr',
        NOK: 'kr',
        DKK: 'kr',
        PLN: 'zł',
        TRY: '₺',
        SGD: 'S$',
        HKD: 'HK$',
        MXN: 'MX$',
        BRL: 'R$',
        ZAR: 'R'
    };

    var updateCurrencyDisplayTimer = null;
    function updateCurrencyDisplay() {
        if(updateCurrencyDisplayTimer != null){
            clearTimeout(updateCurrencyDisplayTimer);
        }

    document.querySelectorAll('.price-item').forEach(function(price) {
        var currency = price.querySelector('.ak_currency');

        if (!currency) {
            return;
        }

        var money = price.querySelector('.money');

        // Case: <span class="money">£24.65</span>
        
        if (money) {
            var firstNode = money.firstChild;

            if (firstNode && firstNode.nodeType === 3) {
                var value = firstNode.nodeValue;

                var match = value.match(
                    /^\s*([^\d\s.,]+)\s*|\s*([^\d\s.,]+)\s*$/
                );

                if (match) {
                    currency.textContent = match[1] || match[2];
                    firstNode.nodeValue = value.replace(match[0], '');
                }
            }

            return;
        }


        // Case: $48<span class="ak_currency">€</span>
        price.childNodes.forEach(function(node) {
            if (node.nodeType === 3) {
                var value = node.nodeValue;

                // Match currency at the beginning or end
                var match = value.match(/^\s*([^\d\s.,]+)\s*|\s*([^\d\s.,]+)\s*$/);

                if (match) {
                    currency.textContent = match[1] || match[2];

                    node.nodeValue = value.replace(match[0], '');
                }
            }
        });

        
    });

    document.querySelectorAll('.price-item').forEach(function(item) {
        item.style.opacity = '1';
    });

        updateCurrencyDisplayTimer = setTimeout(function(){
            updateCurrencyDisplay();
        }, 800);
    }

    // Run on page load
    setTimeout(function(){
    updateCurrencyDisplay();

    }, 1500);

    /* end currency and price coonverter */

    /* start language ask modal */

    $('body .AK-modal-language-selector-logo-container img').css({
        'height': '12px',
    });
    setTimeout(function(){
        $('body .AK-modal-language-selector-logo-container img').css({
            'height': '11px',
        })
    }, 500);
    /* end language ask modal */

    /* start top mini bar */
    function addTopAnnouncementBar() {
        // Prevent duplicate bar
        if (document.getElementById('custom-top-announcement-bar')) return;

        const bar = document.createElement('div');

        bar.id = 'custom-top-announcement-bar';
        bar.innerHTML = `
            ${locale_top_mini_bar_text}
            <a href="mailto:info@fithome.es">info@fithome.es</a>
        `;

        Object.assign(bar.style, {
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            background: '#2d2d2d',
            color: '#d8d0c5',
            // display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            padding: '11px 8px',
            boxSizing: 'border-box',
            zIndex: '999999',
            fontSize: '13px',
            lineHeight: '1.4',
            fontFamily: "Manrope",
        });

        const link = bar.querySelector('a');

        Object.assign(link.style, {
            color: '#d8d0c5',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontFamily: "Manrope",
        });

        document.body.prepend(bar);

        // Prevent the fixed bar from covering page content
        document.body.style.paddingTop =
            bar.offsetHeight + 'px';
    }

    // Run after DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', addTopAnnouncementBar);
    } else {
        addTopAnnouncementBar();
    }
    /* END top mini bar */


    WAChangeText();
    akProductCounter();
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    $('.svg-icon.activeSVG[data-column="2"]').click();
    if($('#shopify-section-template--20614588662027__hero_video_nBJXFG').get(0) && isDesktop()){
        $('#shopify-section-template--20614588662027__hero_video_nBJXFG, #shopify-section-template--20614588662027__slideshows_gijiDK').css({
            'min-height': '100vh',
            'height': '100vh',
        });
    
        // $('#shopify-section-template--20614588662027__hero_video_nBJXFG, #shopify-section-template--20614588662027__slideshows_gijiDK').wrapAll('<div class="ak-wrapper"></div>');
        $(".index-section--hero").wrapAll('<div class="ak-wrapper"></div>');
        $('.ak-wrapper').wrap('<div class="ak-wrapper-container"></div>');
        startOnePage({
            frame: ".ak-wrapper-container",
            container: ".ak-wrapper",
            // sections: "#shopify-section-template--20614588662027__hero_video_nBJXFG, #shopify-section-template--20614588662027__slideshows_gijiDK",
            section: ".index-section--hero:nth-child(1), .index-section--hero:nth-child(2)",
            radio: "#radio",
            radioOn: "#radioOn",
            speed: 500,
            easing: "swing"
        });
        
        setTimeout(function(){
            $(window).bind("load resize", function(){
                $(window).scrollTop(0);
            });
        }, 200);
    }

    $(document).on('click', '.footer-block__heading.inline-richtext', function(){
        $(this).next('.collapsible-content').slideToggle();;
    });

    $('#HeaderDrawer-furniture').on('click', function(){
        console.log(typeof $('#HeaderDrawer-furniture').parent().attr('open'));
        if(typeof $('#HeaderDrawer-fitness-products').parent().attr('open') != 'undefined'){
            $('#HeaderDrawer-fitness-products').click();
        }
    });
    
    
    $('#HeaderDrawer-fitness-products').on('click', function(){
        console.log(typeof $('#HeaderDrawer-furniture').parent().attr('open'));
        if(typeof $('#HeaderDrawer-furniture').parent().attr('open') != 'undefined'){
            $('#HeaderDrawer-furniture').click();
        }
    }); 


    var sliderGallery = document.getElementById('Slider-Gallery-mobilepp');

    var progressBar = document.getElementById('progressBar');
    
    // Remove existing listeners
    function removeScrollListeners(element) {
        if(element == null){
            return;
        }
        const clone = element.cloneNode(true);
        element.parentNode.replaceChild(clone, element);
        return clone;
    }
    
    sliderGallery = removeScrollListeners(sliderGallery);
    if(typeof sliderGallery != 'undefined'){
        sliderGallery.addEventListener('scroll', () => {
        // Calculate available scroll space
        var scrollSpace = sliderGallery.scrollHeight - sliderGallery.clientHeight;
        
        // Calculate available progress bar space
        var progressBarContainer = progressBar.parentElement;
        var progressBarSpace = progressBarContainer.clientHeight - progressBar.clientHeight;
        
        // Calculate proportional position
        var scrollPercent = (sliderGallery.scrollTop / scrollSpace) * progressBarSpace;
        
        progressBar.style.top = `${scrollPercent}px`;  // Using pixels instead of percentage
        });

    }

});

var wishlistHtml;
document.addEventListener('DOMContentLoaded', () => {

    $(document).on('click', '#ak-close-modal-button', function(){
        $('#predictive-search-results-overlay, .predictive-search.predictive-search--search-template, .header__search.large-up-hide').hide();
    });

    const dropdowns = document.querySelectorAll('.ak-dropdown');
    
    dropdowns.forEach((dropdown) => {
        const btn = dropdown.querySelector('.ak-dropdown-btn');
        const content = dropdown.querySelector('.ak-dropdown-content');
    
        btn.addEventListener('click', (event) => {
            event.stopPropagation(); // Prevent triggering the document click
            closeAllDropdowns(); // Optional: close other dropdowns before opening this one
    
            btn.classList.toggle('ak-active');
            content.classList.toggle('ak-show');
        });
    });

    var targetfirstLink = $('footer .ak-dropdown-content a:nth-child(1)');
    targetfirstLinkStr = targetfirstLink.attr('href');
    if(targetfirstLinkStr != null){
        targetfirstLinkStr = targetfirstLinkStr.replace(/\/es\/?($|\/)/, '/');
        targetfirstLink.attr('href', targetfirstLinkStr); 
    }
    
    // Close dropdowns when clicking outside
    document.addEventListener('click', () => {
        closeAllDropdowns();
    });
    
    function closeAllDropdowns() {
        document.querySelectorAll('.ak-dropdown-btn.ak-active').forEach((btn) =>
            btn.classList.remove('ak-active')
        );
        document.querySelectorAll('.ak-dropdown-content.ak-show').forEach((content) =>
            content.classList.remove('ak-show')
        );
    }
    
    $('#Slider-template--20614588727563__multicolumn_3pqVFG').owlCarousel({
        loop:false,
        responsiveClass:true,
        nav:false,
        dots:false,
        responsive:{
            0:{
                items:1,
            },
            600:{
                items:3,
            },
            1000:{
                items:2,
            }
        }
    });

    /* AK start wishlist feature  */

    const WISHLIST_KEY = 'shopify-wishlist';
    if(localStorage.getItem(WISHLIST_KEY)){
        let wishlist = Array.from(JSON.parse(localStorage.getItem(WISHLIST_KEY))) || [];
    }else{
        let wishlist = [];
    }

    // Function to save to localStorage
    function saveWishlist() {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
    }

    function removeWishlist(targetProductId = 0){
        const tmpArr = JSON.parse(localStorage.getItem(WISHLIST_KEY));
        var newTmpArr = [];
        tmpArr.forEach(element => {
            var productId = element.id;
            if(targetProductId == productId){
                // skip
            }else{
                newTmpArr = element;
            }
        });
        console.log("newTmpArr", newTmpArr);
        localStorage.setItem(WISHLIST_KEY, JSON.stringify(newTmpArr));
        // console.log(tmpArr);
    } // end func

    // Function to update button state
    function updateButtons() {
        $('.swym-button[data-product-id]').each(function() {
            const id = $(this).data('product-id').toString();
            if (wishlist.includes(id)) {
            $(this).addClass('active');
            $(this).find('.swym-tooltip-text').text('Remove from wishlist');
            } else {
            $(this).removeClass('active');
            $(this).find('.swym-tooltip-text').text('Add to wishlist');
            }
        });
    }

    var akPathname = location.pathname;
    if(akPathname == '/pages/swym-share-wishlist'){
        wishlistHtml = '<ul class="swym-wishlist-grid ak-swym-wishlist-grid" >';
        var tmpArr = JSON.parse(localStorage.getItem("shopify-wishlist"));
            
            tmpArr.forEach(element => {
                wishlistHtml += '<li><a href="#ak-remove-wishlist"><svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6L11 11L16 6" stroke="#FD1717" stroke-width="12" stroke-linecap="round"/></svg></a>'+element.akHtml+'</li>';
            });
        wishlistHtml += '</ul>';
        console.log("wishlistHtml", typeof wishlistHtml);
        setTimeout(function(){
            $('.swym-empty-readonly-wishlist-detail').append(wishlistHtml);
        }, 1500);
    } // end if 

    document.addEventListener('click', function(e) {
        
        var $btn = $(e.target);
        console.log("ak is", $btn.get(0));
        if($btn.is('.swym-button[data-product-id]') || $btn.parents('li').is('.swym-button[data-product-id]')){

            const productId = $btn.data('product-id').toString();
            alert(productId);
            const variantId = $btn.data('variant-id');
            const productUrl = $btn.data('product-url');
            const akHtml = '<div class="grid__item.product__slide">'+$btn.parents('.grid__item.product__slide').html()+'</div>';

            const item = {
                id: productId,
                variant: variantId,
                url: productUrl,
                akHtml: akHtml,
            };
            const index = wishlist.findIndex(p => p.id === productId);
            
        
            if (index === -1) {
                wishlist.push(item);
                $btn.addClass('active');
            } else {
                wishlist.splice(index, 1);
                $btn.removeClass('active');
            }
        
            saveWishlist();
            updateButtons();
        }else if($btn.parent().is('a[href="#swym-wishlist"]')){
            wishlistHtml = '<ul class="swym-wishlist-grid ak-swym-wishlist-grid" >';
            var tmpArr = JSON.parse(localStorage.getItem(WISHLIST_KEY));
            if ($btn.get(0)) {
                
                tmpArr.forEach(element => {
                    wishlistHtml += '<li><a href="#ak-remove-wishlist"><svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6L11 11L16 6" stroke="#FD1717" stroke-width="12" stroke-linecap="round"/></svg></a>'+element.akHtml+'</li>';
                });
            }
            wishlistHtml += '</ul>';
            console.log("wishlistHtml", typeof wishlistHtml);
            setTimeout(function(){
                $('.swym-wishlist-detail-content').append(wishlistHtml);
            }, 1500);

        }else if($btn.is('[href="#ak-remove-wishlist"]')){
            var tmpArr = JSON.parse(localStorage.getItem(WISHLIST_KEY));
            var targetListIndex = 0;
            var targetLi = $btn.parents('li').index() + 1;
            if ($btn.get(0)) {
                $(`ul.swym-wishlist-grid > li:nth-child(${targetLi})`).find('');
                var akProductId = $btn.parents('li').find('[data-swaction="addToWishlist"]').data('product-id');
                console.log("akProductId", akProductId);
                removeWishlist(akProductId);
            }
            window.location.reload();
       }
        
    }, true); // <-- important: capture = true
    
    /* AK end wishlist feature  */

    /* AK start home page banner 1 font adjustment  */
    const heading = document.querySelector(".shopify-section.index-section--hero:nth-child(1) h2");
        
    if (heading) {
        // 1. Get raw HTML string
        let updatedHTML = heading.innerHTML; 
        
        // 2. Wrap your target keywords in a span tag
        updatedHTML = updatedHTML.replace(/(compacta|compact)/gi, '<span>$1</span>');
        
        // 3. Force browser line breaks wherever a newline break exists
        // updatedHTML = updatedHTML.replace(/\n/g, '<br />');
        
        // 4. Update the DOM
        heading.innerHTML = updatedHTML;
    }
    /* AK end home page banner 1 font adjustment  */

    /* AK start currency  */
        var akFetchSelectedCountryTimer = null;
        function akFetchSelectedCountry(){
            if(akFetchSelectedCountryTimer != null){
                clearTimeout(akFetchSelectedCountryTimer);
            }
            var akSelectedCurrencyStorage = localStorage.getItem('akSelectedCountry_');
            if(akSelectedCurrencyStorage != null){
                var akSelectedCountry = akSelectedCurrencyStorage;
                $('.ak-header-currency-lang-center a').text(akSelectedCountry);
                $('body .footer-globe span.int').text(akSelectedCountry);
            }else{
                
                var akSelectedCurrency = $.trim($('.bucks-selected').text());
                var akSelectedCountry = getCountryByCurrency(akSelectedCurrency);
                if(akSelectedCurrency){
                    $('.ak-header-currency-lang-center a').text(akSelectedCountry);
                    $('body .footer-globe span.int').text(akSelectedCountry);
                }else{
                    akFetchSelectedCountryTimer = setTimeout(function(){
                        akFetchSelectedCountry();
                    }, 100);
                }
            }
        }

        var akAvailableLocales = [];
        function getCountryByCurrency(currency) {
            console.log("getCountryByCurrency", currency);
            akAvailableLocales = [];
            currency = currency.toUpperCase();
            var akSelectedCountry_ = localStorage.getItem('akSelectedCountry_');
            if(akSelectedCountry_){
                akAvailableLocales = akCurrencies[akSelectedCountry_].languages;
                return akSelectedCountry_;
            }else{
                for (var country in akCurrencies) {
                    console.log("country", country)
                    if (
                        akCurrencies[country].currency_code.toUpperCase() === currency ||
                        akCurrencies[country].currency_label.toUpperCase() === currency
                    ) {
                        akAvailableLocales = akCurrencies[country].languages;
                        return country;
                    }
                }

            }

            return 'Spain';
        }

        var akFooterTopLocalePos = 0;

    (function () {
        var popupHTML = ` 
            <style>
                .buckscc-currency-wrapper{
                    display: none !important;
                }
                .ak-header-currency-lang-center a, .ak-header-currency-lang-right  a{
                    color: black;
                }
                .template--index .ak-header-currency-lang-container{
                    div.border-left{
                        border-color: white !important;
                    }
                    a, span{
                        color: white !important;                
                    }
                    path{
                        stroke: white;
                    }
                    .ak-dropdown-content.ak-dropdown-content-modal-language-selector{
                        a{
                            color:  black !important;
                        }
                    }
                }
                .ak-header-currency-lang-right{
                    .ak-dropdown{
                        border-left: unset !important;
                    }
                    .ak-dropdown-content.ak-dropdown-content-modal-language-selector{
                        display: none;
                        height: auto;
                        max-height: unset;
                        top: 28px;
                        left: -9px;
                        padding-top: 6px;
                        padding-bottom: 6px;
                        min-width: unset !important;
                        width: auto !important;
                    }
                    .ak-dropdown-content.ak-dropdown-content-modal-language-selector a{
                        padding-top: 0;
                        height: 32px;
                        padding-left: 10px;
                        padding-right: 30px;
                    }

                }
                .ak-country-popup-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: transparent;
                    display: none;
                    align-items: center;
                    justify-content: center;
                    z-index: 99999;
                    padding: 10px;
                    box-sizing: border-box;

                }
                .ak-country-popup-overlay::before {
                    content: "";
                    position: absolute;
                    inset: 0;
                    background: rgba(0, 0, 0, 0.3);
                    backdrop-filter: blur(10px);
                    -webkit-backdrop-filter: blur(10px);
                    z-index: 0;
                }


                .ak-country-popup {
                    width: 100%;
                    max-width: 533px;
                    background: #f1efec;
                    border-radius: 4px;
                    padding: 42px 49px 54px;
                    box-sizing: border-box;
                    text-align: center;
                    z-index: 100000;
                }


                .ak-country-popup-logo {
                    font-size: 18px;
                    font-weight: 500;
                    letter-spacing: 1px;
                    line-height: 1;
                    color: #000;
                    margin-bottom: 32px;
                }

                .ak-country-popup-question {
                    font-size: 14.5px;
                    font-weight: 400;
                    line-height: 1.25;
                    color: #000;
                    margin-bottom: 29px;
                }

                .ak-country-popup-buttons {
                    display: flex;
                    gap: 9.5px;
                    width: 100%;
                }

                .ak-country-popup-buttons button {
                    flex: 1;
                    height: 47px;
                    border: 0;
                    border-radius: 0;
                    font-size: 14px;
                    font-weight: 400;
                    cursor: pointer;
                    padding: 0 10px;
                    transition: opacity 0.2s ease;
                    font-family: var(--font-body-family);
                }

                .ak-country-popup-buttons button:hover {
                    opacity: 0.85;
                }

                .ak-country-popup-keep {
                    background: #d9cbb3;
                    color: #000;
                }

                .ak-country-popup-change {
                    background: #242424;
                    color: #fff;
                }
                .ak-header-currency-lang-right [data-language-code]{
                    cursor: pointer;
                    display: none;
                }

                @media screen and (max-width: 767px) {

                    .ak-country-popup-overlay {
                        padding: 10px;
                    }

                    .ak-country-popup {
                        max-width: 100%;
                        padding: 25px 18px 28px;
                    }

                    .ak-country-popup-logo {
                        font-size: 14px;
                        margin-bottom: 28px;
                    }

                    .ak-country-popup-question {
                        font-size: 12px;
                        margin-bottom: 20px;
                    }

                    .ak-country-popup-buttons {
                        flex-direction: column;
                        gap: 6px;
                    }

                    .ak-country-popup-buttons button {
                        width: 100%;
                        height: 33px;
                        font-size: 11px;
                    }

                    body .ak-header-currency-lang-container{
                        display: none;
                    }
                    body .footer-globe span.int{
                        /*display: none;*/
                        cursor: pointer;
                    }
                    body .footer-globe{
                        .ak-dropdown{
                            border-left: unset;
                        }
                    }
                    body .ak-device-open-initial-popup-container{
                        display: flex; justify-content: center; align-items: center; gap: 5px;
                        a{
                            color: black;
                        }
                        
                    }
                    body .ak-country-popup-overlay{
                        padding: 0 !important;
                        z-index: 9999999999;
                    }
                    body .ak-country-popup{
                        bottom: 0;
                        position: fixed;
                    }
                    body .ak-country-popup-buttons button{
                        font-size: 16px;
                        padding: 10px;
                        font-weight: 600;
                    }
                }
                @media screen and (max-width: 1200px) {
                    .ak-header-currency-lang-container{
                        display: none;
                    }
                }
                @media only screen and (max-width: 1199px) {
                    body .footer-globe {
                        display: flex;
                    }
                }
            </style>
            <div class="ak-country-popup-overlay">
                <div class="ak-country-popup">

                    <div class="ak-country-popup-logo">
                        <img src="https://cdn.shopify.com/s/files/1/0763/7260/7243/files/fithome-black.png?v=1744031541" style="height: 11px;">
                    </div>

                    <div class="ak-country-popup-question">
                        Do you want to shop in another country?
                    </div>

                    <div class="ak-country-popup-buttons">

                        <button type="button" class="ak-country-popup-keep">
                            Keep browsing
                        </button>

                        <button type="button" class="ak-country-popup-change">
                            Change country
                        </button>

                    </div>

                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', popupHTML);

        var akHtml = ` 
            <div class="ak-header-currency-lang-container">
                <style>
                    
                    .ak-header-currency-lang-container{
                        margin-left: 20px;
                        display: flex;
                        align-items: center;
                        gap: 15px;
                        a{
                            font-size: 14px !important;
                            font-weight: 300 !important;
                            line-height: 30px !important;
                            letter-spacing: .02px !important;
                            padding: 0;
                            span{
                                font-size: inherit !important;
                                font-weight: inherit !important;
                                line-height: inherit !important;
                                letter-spacing: inherit !important;
                            }
                        }
                        
                        div.border-left{
                            border-left: 1px solid black;
                            height: 28px;
                            padding: 0;
                            margin: 0;
                            max-height: 28px;
                        }
                        .ak-header-currency-lang-center {
                            display: flex;
                            align-items: center;
                            gap: 8px;
                            position: relative;
                        }
                        
                        .buckscc-select-styled{
                            position: absolute;
                            z-index: -1;
                        }
                        .hxoSelectTheme{
                            position: absolute !important;
                            right: 0 !important;
                            left: 0 !important;
                            top: 26px !important;
                        }
                        .hxoSelectTheme .buckscc-select-styled.deactive.active+.buckscc-select-options, 
                        .hxoSelectTheme .buckscc-select-styled.deactive.active+.buckscc-select-options li{
                            opacity: 1 !important;
                        }
                    }
                </style>
                <div class="ak-header-currency-lang-left border-left"></div>
                <div class="ak-header-currency-lang-center ">
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.375 9.5H6.33333M2.375 9.5C2.375 13.435 5.56497 16.625 9.5 16.625M2.375 9.5C2.375 5.56497 5.56497 2.375 9.5 2.375M6.33333 9.5H12.6667M6.33333 9.5C6.33333 13.435 7.7511 16.625 9.5 16.625M6.33333 9.5C6.33333 5.56497 7.7511 2.375 9.5 2.375M12.6667 9.5H16.625M12.6667 9.5C12.6667 5.56497 11.2489 2.375 9.5 2.375M12.6667 9.5C12.6667 13.435 11.2489 16.625 9.5 16.625M16.625 9.5C16.625 5.56497 13.435 2.375 9.5 2.375M16.625 9.5C16.625 13.435 13.435 16.625 9.5 16.625" stroke="#232323" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <a onclick="$('.ak-country-popup-overlay').fadeIn(); $('.ak-country-popup-overlay').css('display', 'flex')" href="javascript:void(0);"></a>
                </div>
                <div class="ak-header-currency-lang-right ">
                    <!-- <a  onclick="$('.ak-country-popup-overlay').fadeIn(); $('.ak-country-popup-overlay').css('display', 'flex')" href="javascript:void(0);" >Español</a> -->
                    <div class="ak-dropdown">
                        <a href="javascript:void(0)" class="ak-dropdown-btn ak-dropdown-btn-language">
                            <span>${locale_full_language_name}</span>
                            <svg class="ak-dropdown-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 6L8 10L12 6" stroke="#1A1A14" stroke-linecap="round"></path></svg>
                        </a>
                        <div class="ak-dropdown-content ak-dropdown-content-modal-language-selector">
                            <a data-href-label="Spanish" data-language-code="es" data-href="/">Spanish</a>
                            <a data-href-label="English" data-language-code="en" data-href="/en">English</a>
                            <a data-href-label="Catalan" data-language-code="ca" data-href="/ca">Catalan</a>
                        </div>
                    </div>
                </div>
            </div>
        `;
        $('.header__icons').append(akHtml);
        var overlay = document.querySelector('.ak-country-popup-overlay');
        var keepBrowsing = document.querySelector('.ak-country-popup-keep');
        var changeCountry = document.querySelector('.ak-country-popup-change');
        keepBrowsing.addEventListener('click', function () {
            $(overlay).fadeOut();
        });
        changeCountry.addEventListener('click', function () {
            $(overlay).fadeOut();
            $('#AK-modal').show();
        });
        akFetchSelectedCountry();        
        $(document).on('click', '.ak-header-currency-lang-right a', function(){
            var akDisplay = $('.ak-header-currency-lang-right').find('.ak-dropdown-content.ak-dropdown-content-modal-language-selector').css('display');
            if(akDisplay == 'none'){
                $('.ak-header-currency-lang-right').find('.ak-dropdown-content.ak-dropdown-content-modal-language-selector').css('display', 'block');
            }else{
                $('.ak-header-currency-lang-right').find('.ak-dropdown-content.ak-dropdown-content-modal-language-selector').css('display', 'none');
            }

            // var akDisplay2 = $('.footer').find('.ak-dropdown-content').css('display');
            // if(akDisplay2 == 'none'){
            //     $('.footer').find('.ak-dropdown-content').css('display', 'block');
            // }else{
            //     $('.footer').find('.ak-dropdown-content').css('display', 'none');
            // }
        });
        getCountryByCurrency('');
        console.log("akAvailableLocales", akAvailableLocales);
        $('.footer [data-language-code]').hide();
        akAvailableLocales.forEach((v, i) => {
            $(`.ak-header-currency-lang-right [data-language-code="${v}"]`).show();
            $(`.footer [data-language-code="${v}"]`).show();
            akFooterTopLocalePos += 36;
            console.log(`.footer [data-language-code="${v}"]`)
        });
        $('footer .ak-dropdown-content').css('top', `-${akFooterTopLocalePos}px`)
        
        $(document).on('click', '.ak-header-currency-lang-right [data-language-code], .footer [data-language-code]', function(){
            var newLanguage = $(this).data('language-code');
            if(newLanguage == 'es'){
                newLanguage = '';
            }
            var url = new URL(window.location.href);

            // Replace the existing language code or add it to the root path
            var path = url.pathname;

            if (/^\/(en|es|ca)(\/|$)/.test(path)) {
                path = path.replace(/^\/(en|es|ca)(?=\/|$)/, '/' + newLanguage);
            } else {
                path = '/' + newLanguage + (path === '/' ? '' : path);
            }

            url.pathname = path;

            var newUrl = url.toString();
            console.log('newUrl:', newUrl, newLanguage);

            // Redirect to the new URL
            window.location.href = newUrl;

        });
        if(typeof akSelectedCountry == 'undefined'){
            akSelectedCountry = '';
        }
            $(`[data-country="${akSelectedCountry}"]`).click()
        
        var akSelectedCurrencyStorage = localStorage.getItem('akSelectedCountry_');
        var akSmallDeviceHtml = `
            <div class="ak-device-open-initial-popup-container">
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.375 9.5H6.33333M2.375 9.5C2.375 13.435 5.56497 16.625 9.5 16.625M2.375 9.5C2.375 5.56497 5.56497 2.375 9.5 2.375M6.33333 9.5H12.6667M6.33333 9.5C6.33333 13.435 7.7511 16.625 9.5 16.625M6.33333 9.5C6.33333 5.56497 7.7511 2.375 9.5 2.375M12.6667 9.5H16.625M12.6667 9.5C12.6667 5.56497 11.2489 2.375 9.5 2.375M12.6667 9.5C12.6667 13.435 11.2489 16.625 9.5 16.625M16.625 9.5C16.625 5.56497 13.435 2.375 9.5 2.375M16.625 9.5C16.625 13.435 13.435 16.625 9.5 16.625" stroke="#232323" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <a class="footer-selected-country" onclick="$('.ak-country-popup-overlay').fadeIn(); $('.ak-country-popup-overlay').css('display', 'flex')" href="javascript:void(0);">${akSelectedCurrencyStorage}</a>
            </div>
        `;
        $(akSmallDeviceHtml).insertBefore($('.footer-globe .ak-dropdown'));

    })();
    /* AK end currency  */

}); 